import { Button, Col, Input, Row, Table, Modal, Switch, Popconfirm, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
// import { AddTags } from "./AddTags";
// import { setHeaderName } from "../../../../services/SetHeaderName";
// import { AddPlanPricing } from "./AddPlanPricing";
import '../../style/AssignedHerbs.scss'
import { AddHerb } from "./AddHerb";
import { setHeaderName } from "../../../../../../services/SetHeaderName";
import { listOfAssignHerbApi, updateAssignHerbApi } from "../../../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../../../config/constant";
import { useParams } from "react-router-dom";

export const AssignedHerbsList = () => {
    const [isModalVisible, setIsModalVisible] = useState(false)
    const { id } = useParams()

    const [assignedHerData, setAssignedHerData] = useState();
    const [isActive, setIsActive] = useState(false)
    const [dataSource, setDataSource] = useState();
    const [displayData, setDisplayData] = useState([]);
    const [loading, setLoading] = useState(false)

    // list of all assigned herbs
    const getListOfAssignedHerbsList = () => {
        setLoading(true)

        listOfAssignHerbApi({ "patient_id": parseInt(id) })
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)

            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // const data = [
    //     {
    //         id: '1001',
    //         herb: 'Amalaki',
    //         quantity: '5',
    //         unit: "Milligrams",
    //         remark: "Mansi Bhojani",
    //         mealtimes: "Breakfast",
    //         date: "31 Aug,2022",
    //         nutritionist: "Mansi Bhojani",
    //         active: false,
    //     },
    //     {
    //         id: '1002',
    //         herb: 'Aloe Vera',
    //         quantity: '1',
    //         unit: "Grams",
    //         remark: "Mansi Bhojani",
    //         mealtimes: "Dinner",
    //         date: "31 Aug,2022",
    //         nutritionist: "Aakash Parekh",
    //         active: false,
    //     },
    //     {
    //         id: '1003',
    //         herb: 'Ajwain Water',
    //         quantity: '5',
    //         unit: "Tablet",
    //         remark: "Darshit Lathigara",
    //         mealtimes: "Lunch",
    //         date: "31 Aug,2022",
    //         nutritionist: "Darshit Lathigara",
    //         active: false,
    //     },

    // ];


    // filter assigned herbs data according to user input 
    const filterAssignedHerbs = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.herb.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    useEffect(() => {
        setHeaderName("Herb Management")
        getListOfAssignedHerbsList()
    }, []);

    // update status of recipe category
    const onChange = (checked, data) => {
        // let updatedData = data;
        // updatedData.status = checked;
        // console.log(data);
        const apiData = {
            "herb": data.herb,
            "quantity": data.quantity,
            "patient_id": parseInt(id),
            "unit_id": data.unit_id,
            "meal_time_id": data.meal_time_id,
            "remark": data.remark,
            "status": checked
        }
        // console.log(apiData);

        updateAssignHerbApi(data.id, apiData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Assign Herb Update successfully",
                    });
                    getListOfAssignedHerbsList()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const columns = [
        // {
        //     title: 'ID',
        //     dataIndex: 'id',
        //     key: 'name',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.id - b.id,
        //     // render: (text) => <a>{text}</a>,
        // },
        {
            title: 'Herb',
            dataIndex: 'herb',
            key: 'herb',
            sorter: (a, b) => a.herb.localeCompare(b.herb),
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
        },
        {
            title: 'Unit',
            dataIndex: 'unit',
            key: 'unit',
            render: (text) => <p className="mb-0">{text?.name}</p>,
        },
        {
            title: 'Remark',
            dataIndex: 'remark',
            key: 'remark',
        },
        {
            title: 'Mealtimes',
            dataIndex: 'meal_time',
            key: 'mealtimes',
            render: (text) => <p className="mb-0">{text?.name}</p>,
        },
        {
            title: 'Date',
            dataIndex: 'created_at',
            key: 'date',
            render: (text, data) => <p className="mb-0">{text?.split('T')[0]}</p>
        },
        {
            title: 'Nutritionist',
            dataIndex: 'user',
            key: 'user',
            render: (text, data) => <p className="mb-0">{text?.name}</p>

        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "Deactive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        // {
        //     title: 'Action',
        //     key: 'action',
        //     render: (_, record) => (
        //         <div className="action align-self-center">
        //             <Popconfirm title="Sure to delete?" >
        //                 <Button icon={<DeleteOutlined />} className="me-2" />
        //             </Popconfirm>
        //         </div>
        //     ),
        // },
    ];

    return (
        <>
            <AddHerb getListOfAssignedHerbsList={getListOfAssignedHerbsList} />
            <div className="AssignedHerbsList">
                <Row className="mb-2">
                    <Col xs={12} sm={12} md={4} lg={4} xl={6} xxl={5} className="align-self-center">
                        <h4 className="ms-2 mb-0">Assigned Herbs</h4>
                    </Col>
                    <Col xs={12} sm={12} md={8} xl={12} xxl={15} className="text-end align-self-center pe-4">
                        <h6 className="mb-0">Total Herbs: {displayData.length > 0 ? displayData.length : 0} </h6>
                    </Col>
                    <Col xs={24} sm={12} md={12} xl={6} xxl={6} className="align-self-center pe-2">
                        <Input.Search placeholder="Search Users"
                            onChange={(e) => { filterAssignedHerbs(e.target.value); setAssignedHerData(e.target.value) }}

                            // onChange={e => {
                            //     let currValue = e.target.value;
                            //     let filteredData = data.filter(entry =>
                            //         entry.herb.toLowerCase().includes(currValue.toLowerCase()) ||
                            //         entry.mealtimes.toLowerCase().includes(currValue.toLowerCase()) ||
                            //         entry.nutritionist.toLowerCase().includes(currValue.toLowerCase())
                            //     );
                            //     setDataSource(filteredData);
                            // }}
                            className="p-2" />
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Table
                            columns={columns}
                            dataSource={displayData}
                            // pagination={false}
                            rowKey="id"
                            scroll={{ x: "max-content" }}
                            className="w-100"
                        />
                    </Row>
                </Spin>
            </div>
        </>
    )
}
